import MyOrdersList from "@/components/modules/account/my-orders-list";
import { __ } from "@/lib/i18n/functions";
import React from "react";

type AccountMyOrdersProps = {
  resolution: Resolution;
};

const AccountMyOrders = ({ resolution }: AccountMyOrdersProps) => {
  return (
    <div className="flex-1/2 overflow-x-auto">
      <h2 className="font-cabinet-grotesk mb-5 text-2xl font-medium md:text-3xl">
        {__("My order history", resolution?.locale)}
      </h2>
      <MyOrdersList locale={resolution?.locale} />
    </div>
  );
};

export default AccountMyOrders;
